module.exports = __webpack_public_path__ + "img/close-secondary.86165337.svg";